export default __webpack_public_path__ + "static/media/apple-badge.8c46051a.svg";